<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import _ from "lodash";
import VDataTableWordClouds from "@/components/VDataTable/VDataTableWordClouds.vue";

export default {
    name: "ProjectsWordclouds",
    components: {
        VDataTableWordClouds,
        AjaxLoad,
    },
    props: {
        idProject: {
            type: String,
        },
    },
    methods: {
        transformWordCloudResponse(response) {
            return _.orderBy(response?.data?.data, 'date_end');
        },
        onDblClickWordCloud(e, {item}) {
            this.$router.push({
                name: 'ForumEventWordCloud',
                params: {ID_WORDCLOUDS: item.id},
            });
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        :active="!!idProject"
        :url="$apiUrl.getWordCloudsUrl({id_project: idProject})"
        :transform="transformWordCloudResponse"
        v-slot="{data: dataWordClouds, resolved, active}"
    >
        <v-data-table-word-clouds
            :items="dataWordClouds"
            :loading="!resolved && !!active"
            :footer-props="{itemsPerPageOptions:[20]}"
            @dblclick:row="onDblClickWordCloud"
            @click:reload="() => $refs.ajax.load()"
            heading="Облака смыслов"
            search=""
            with-toolbar
        ></v-data-table-word-clouds>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
